module.exports = __webpack_public_path__ + "img/inventory.01547e47.svg";